import { useQuery } from '@tanstack/react-query';

import { getJobmarketFaculties } from 'api';
import { AxiosRequestConfig } from 'axios';

/**
 * A custom hook to fetch all faculties from the JobmarketService.
 *
 * @returns DefinedUseQueryResult<Faculty[], Error>
 */
export const useJobmarketFacultiesQuery = (config?: AxiosRequestConfig) => {
  const query = useQuery({
    queryKey: ['jobmarketFaculties'],
    queryFn: () => {
      const faculties = getJobmarketFaculties(config);
      return faculties;
    },
    initialData: []
  });
  return query;
};
